import actions from "./actions";

const initState = {
  history: [],
  schools: [],
  grades: [],
  classrooms: [],
  subjects: [],
  roles: [],
  userList: [],
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_HISTORY_MEETING_SUCCESS:
      return { ...state, history: action.data };

    case actions.FETCH_CONFIGS_SUCCESS_BBM:
      return {
        ...state,
        schools: action.schools,
        grades: action.grades,
        subjects: action.subjects,
        roles: action.role,
        classrooms: action.classrooms,
      };

    case actions.FETCH_USER_LIST_BBB_SUCCESS:
      return { ...state, userList: action.users };

    default:
      return state;
  }
}
